import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CreateOrganization,
  useAuth as useClerkAuth,
  useOrganization,
  useOrganizationList,
} from '@clerk/clerk-react';
import AuthShell, { clerkAppearance } from '../components/auth/AuthShell';
import LoadingSpinner from '../components/ui/LoadingSpinner';

/**
 * Après inscription Clerk : création de l'organisation (= client JULIA).
 * Le créateur devient org:admin → rôle RH.
 */
const CreateOrganizationPage: React.FC = () => {
  const navigate = useNavigate();
  const { isLoaded: authLoaded, isSignedIn } = useClerkAuth();
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const { isLoaded: listLoaded, userMemberships, setActive } = useOrganizationList({
    userMemberships: { infinite: true },
  });

  useEffect(() => {
    if (!authLoaded) return;
    if (!isSignedIn) {
      navigate('/register', { replace: true });
    }
  }, [authLoaded, isSignedIn, navigate]);

  useEffect(() => {
    if (!orgLoaded || !listLoaded || !isSignedIn) return;

    if (organization) {
      navigate('/dashboard', { replace: true });
      return;
    }

    const memberships = userMemberships?.data ?? [];
    if (memberships.length === 1 && setActive) {
      void setActive({ organization: memberships[0].organization.id }).then(() => {
        navigate('/dashboard', { replace: true });
      });
    }
  }, [orgLoaded, listLoaded, organization, userMemberships, setActive, isSignedIn, navigate]);

  if (!authLoaded || !orgLoaded || !listLoaded || !isSignedIn) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <LoadingSpinner size={40} />
      </div>
    );
  }

  return (
    <AuthShell
      title="Votre entreprise"
      subtitle="Créez l’organisation de votre client pour isoler vos données RH"
    >
      <CreateOrganization
        afterCreateOrganizationUrl="/dashboard"
        skipInvitationScreen
        appearance={clerkAppearance}
      />
    </AuthShell>
  );
};

export default CreateOrganizationPage;
